import React, { useState, useEffect } from "react";
import {
  VictoryChart,
  VictoryTheme,
  VictoryGroup,
  VictoryArea,
  VictoryPolarAxis,
  VictoryLabel,
  VictoryContainer,
} from "victory";

const characterData = [
  {
    PCRA: 33,
    TCRA: 22,
    DEPAL: 11,
    "COM/LFS": 13,
    WRAPPER: 50,
    SPECIAL: 1,
    "VC/TC": 20,
    CONVEYORS: 80,
    PRINTERS: 10,
    ELECTRICAL: 10,
  },
  {
    PCRA: 46,
    TCRA: 24,
    DEPAL: 22,
    "COM/LFS": 29,
    WRAPPER: 50,
    SPECIAL: 23,
    "VC/TC": 20,
    CONVEYORS: 80,
    PRINTERS: 40,
    ELECTRICAL: 26,
  },
];

// const getMaxima = (data) => {
//   const groupedData = Object.keys(data[0]).reduce((memo, key) => {
//     memo[key] = data.map((d) => d[key]);
//     return memo;
//   }, {});
//   return Object.keys(groupedData).reduce((memo, key) => {
//     memo[key] = Math.max(...groupedData[key]);
//     return memo;
//   }, {});
// };

const getMaxima = () => {
  return {
    PCRA: 80,
    TCRA: 80,
    DEPAL: 80,
    "COM/LFS": 80,
    WRAPPER: 80,
    SPECIAL: 80,
    "VC/TC": 80,
    CONVEYORS: 80,
    PRINTERS: 80,
    ELECTRICAL: 80,
  };
};

const processData = (data, maxima) => {
  const makeDataArray = (d) => {
    return Object.keys(d).map((key) => {
      return { x: key, y: d[key] / maxima[key] };
    });
  };
  return data.map((datum) => makeDataArray(datum));
};

// Custom component to render the filter
const FilterDefs = () => (
  <defs>
    <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
      <feOffset result="offOut" in="SourceAlpha" dx="3" dy="3" />
      <feGaussianBlur result="blurOut" in="offOut" stdDeviation="5" />
      <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
    </filter>
  </defs>
);

const CompetencyChart = () => {
  const [data, setData] = useState([]);
  const [maxima, setMaxima] = useState({});

  useEffect(() => {
    const maxima = getMaxima(characterData);
    const processedData = processData(characterData, maxima);
    setData(processedData);
    setMaxima(maxima);
  }, []);

  return (
    <VictoryChart
      polar
      theme={VictoryTheme.material}
      domain={{ y: [0, 1] }}
      containerComponent={<VictoryContainer />}
    >
      <FilterDefs />
      <VictoryGroup
        colorScale={[
          "var(--color-witron-blue)",
          "var(--color-grey-600)",
          // ... Add more colors as needed
        ]}
        style={{ data: { fillOpacity: 0.1, strokeWidth: 1 } }}
      >
        {data.map((data, i) => (
          <VictoryArea
            key={i}
            data={data}
            style={{
              data: {
                filter: "url(#shadow)",
              },
            }}
          />
        ))}
      </VictoryGroup>
      {Object.keys(maxima).map((key, i) => (
        <VictoryPolarAxis
          key={i}
          dependentAxis
          style={{
            axisLabel: {
              padding: 10,
              fontSize: "10px",
              fill: "var(--color-grey-500)",
            },
            axis: { stroke: "none" },
            grid: { stroke: "grey", strokeWidth: 0.25, opacity: 0.2 },
            tickLabels: { fontSize: "9px", fill: "var(--color-grey-500)" },
          }}
          tickLabelComponent={<VictoryLabel labelPlacement="vertical" />}
          labelPlacement="perpendicular"
          axisValue={i + 1}
          label={key}
          tickFormat={(t) => Math.ceil(t * maxima[key])}
          tickValues={[0.5, 0.75]}
        />
      ))}
      <VictoryPolarAxis
        labelPlacement="parallel"
        tickFormat={() => ""}
        style={{
          axis: { stroke: "none" },
          grid: { stroke: "grey", opacity: 0.5 },
        }}
      />
    </VictoryChart>
  );
};

export default CompetencyChart;
